import * as React from 'react';

import classnames from 'classnames';

import styles from './disabled-section.module.css';

type Props = {
    disabled: boolean;
    children: React.ReactNode;
    heightFitContent?: boolean;
};

DisabledSection.defaultProps = {
    disabled: true,
};

export function DisabledSection(props: Props) {
    const styleName = classnames({
        [styles['disabled-section']]: props.disabled,
        [styles['disabled-section--height-fit-content']]: props.heightFitContent,
    });

    return <div className={styleName}>{props.children}</div>;
}
